import { Pipe, PipeTransform } from '@angular/core';
import { IChatUser } from '../models/chat';

@Pipe({
	name: 'typingUsersLabel',
	standalone: true
})
export class TypingUsersLabelPipe implements PipeTransform {

	transform(users: Array<IChatUser> | null | undefined): string {
		if (!users?.length) return '';

		const names: Array<string> = users
			.map((u: IChatUser): string => u.full_name)
			.filter((name: string): boolean => !!name);

		if (!names.length) return '';

		if (names.length === 1) return names[0];

		if (names.length === 2) return `${names[0]}, ${names[1]}`;

		const visibleNames: string = `${names[0]}, ${names[1]}`;
		const moreCount: number = names.length - 2;
		return `${visibleNames} +${moreCount}`;
	}
}

